import { Grid2 } from "@mui/material";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import Switch from "../../../../../UI/GeneralPurpose/Switch";

export const nameColumnID = "name-column";
export const devicesColumnID = "devices-column";
export const groupColumnID = "group-column";
export const sizeColumnID = "size-column";
export const lastBackupColumnID = "last-backup-column";
export const lastSentColumnID = "last-sent-column";
export const uploadColumnID = "upload-column";
export const versionColumnID = "version-column";
export const connectionColumnID = "connection-column";
export const stateColumnID = "state-column";

const UIText1 = {
  "es-CL": { label: "Usuarios" },
  "en-US": { label: "Users" },
};
const UIText2 = {
  "es-CL": { label: "Dispositivos" },
  "en-US": { label: "Devices" },
};
const UIText3 = {
  "es-CL": { label: "Grupo" },
  "en-US": { label: "Group" },
};
const UIText4 = {
  "es-CL": { label: "Tamaño" },
  "en-US": { label: "Size" },
};
const UIText5 = {
  "es-CL": { label: "Ultimo respaldo" },
  "en-US": { label: "Last Backup" },
};
const UIText6 = {
  "es-CL": { label: "Ultimo envío" },
  "en-US": { label: "Last Sent" },
};
const UIText7 = {
  "es-CL": { label: "Velocidad de carga" },
  "en-US": { label: "Upload speed" },
};
const UIText8 = {
  "es-CL": { label: "Versión" },
  "en-US": { label: "Version" },
};

const UIText9 = {
  "es-CL": { label: "Conexión" },
  "en-US": { label: "Conection" },
};
const UIText10 = {
  "es-CL": { label: "Estado" },
  "en-US": { label: "State" },
};

const ColumnsList = () => {
  const { UI } = useUIBp();

  return (
    <Grid2 container {...{ size: 12 }}>
      <Switch disabled labelRight {...{ id: nameColumnID, UIText: UIText1, size: 4 }} />
      <Switch disabled labelRight {...{ id: devicesColumnID, UIText: UIText2, size: 4 }} />
      <Switch labelRight {...{ id: groupColumnID, UIText: UIText3, size: 4 }} />
      <Switch labelRight {...{ id: sizeColumnID, UIText: UIText4, size: 4 }} />
      <Switch labelRight {...{ id: lastBackupColumnID, UIText: UIText5, size: 4 }} />
      <Switch labelRight {...{ id: lastSentColumnID, UIText: UIText6, size: 4 }} />
      <Switch labelRight {...{ id: uploadColumnID, UIText: UIText7, size: 4 }} />
      <Switch labelRight {...{ id: versionColumnID, UIText: UIText8, size: 4 }} />
      <Switch labelRight {...{ id: connectionColumnID, UIText: UIText9, size: 4 }} />
      <Switch labelRight {...{ id: stateColumnID, UIText: UIText10, size: 4 }} />
    </Grid2>
  );
};

export default ColumnsList;
